var map;

function initMap() {

  var sawmill = {
    info: '<strong>Diamond Cellar</strong><br>\
					620 Sawmill Rd<br>Dublin, OH 43017<br>\
					<a class="diamond-cellar" href="https://goo.gl/maps/tTLLdonHU3n">Get Directions</a>',
    lat: 40.0947196,
    lng: -83.0907
    }

  var easton = {
    info: '<strong>Diamond Cellar</strong><br>\
					3960 New Bond St<br>Columbus, OH 43219<br>\
					<a class="diamond-cellar" href="https://goo.gl/maps/YezTTcX2Nq62">Get Directions</a>',
    lat: 40.05325755,
    lng: -82.91635
  }
  
    var nashville = {
    info: '<strong>Diamond Cellar</strong><br>\
					3805 Green Hills Village Dr, Nashville, TN 37215<br>\
					<a class="diamond-cellar" href="https://goo.gl/maps/RL2zSb2K6zzznsgDA">Get Directions</a>',
    lat: 36.1086017,
    lng: -86.8187024
  }

  var locations = [
    [sawmill.info, sawmill.lat, sawmill.lng, 0],
    [easton.info, easton.lat, easton.lng, 1],
    [nashville.info, nashville.lat, nashville.lng, 1]
  ];

  var styles = {
    default: null,
    silver:
    [
    {
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6e6c6c"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry",
    "stylers": [
      {
        "weight": "0.85"
      },
      {
        "lightness": "45"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f2f2f2"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "gamma": "1.09"
      },
      {
        "lightness": "19"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "lightness": "-21"
      },
      {
        "weight": "0.01"
      }
    ]
  },
  {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry",
    "stylers": [
      {
        "saturation": "8"
      },
      {
        "lightness": "8"
      }
    ]
  },
  {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "lightness": "6"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      },
      {
        "saturation": "1"
      },
      {
        "color": "#cfe1d3"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.attraction",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.medical",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.medical",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#cfe1d3"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "saturation": -100
      },
      {
        "lightness": 45
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#dcdfe2"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "gamma": "1.57"
      },
      {
        "lightness": "-10"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels",
    "stylers": [
      {
        "weight": "0.01"
      },
      {
        "visibility": "on"
      },
      {
        "saturation": "-100"
      },
      {
        "lightness": "-3"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels.icon",
    "stylers": [
      {
        "weight": "0.01"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c2d8e1"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#b0bdc7"
      }
    ]
  }
]
  }

  var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 10,
		center: new google.maps.LatLng(36.1086017, -86.8187024),
		mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false
	});
  map.setOptions({styles: styles['silver']});

  var infowindow = new google.maps.InfoWindow({
  });

  var marker, i;
	for (i = 0; i < locations.length; i++) {
    var containsDiamond = locations[i].toString().indexOf("Diamond Cellar");
    var containsFive = locations[i].toString().indexOf("STORE 5a");
    if (containsDiamond > -1){
		  marker = new google.maps.Marker({
			  position: new google.maps.LatLng(locations[i][1], locations[i][2]),
			  map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/2318/6005/files/store.svg?v=1589400061",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    } else if (containsFive > -1){
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/2318/6005/files/store.svg?v=1589400061",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    } else {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/2318/6005/files/store.svg?v=1589400061",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    }

		google.maps.event.addListener(marker, 'click', (function (marker, i) {
			return function () {
        if (locations[i][0].includes("Dublin")) {
          $(".info-drawer-columbus").hide();
          $(".info-drawer-nashville").hide();
          $(".info-drawer-dublin").show();
        } if (locations[i][0].includes("Nashville")) {
          $(".info-drawer-dublin").hide();
          $(".info-drawer-columbus").hide();
          $(".info-drawer-nashville").show();
        } else {
          $(".info-drawer-dublin").hide();
          $(".info-drawer-nashville").hide();
          $(".info-drawer-columbus").show();
			  }
      }
		})(marker, i));
}
}
